
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'gallery-arrow-up': {
    width: 5.8,
    height: 6.7,
    viewBox: '0 0 5.8 6.7',
    data: '<path pid="0" d="M.1 3c.2.2.5.2.7 0l1.5-1.6v4.7c0 .3.2.5.5.5s.5-.2.5-.5V1.5L4.9 3c.2.2.5.2.7 0s.2-.5 0-.7l-2-2C3.4.1 3.1 0 2.9 0c-.3 0-.5.1-.7.3l-2 2c-.2.2-.2.5-.1.7z" _fill="#2e3640"/>'
  }
})
